
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-04-23-dbt-from-scratch",
      function () {
        return require("private-next-pages/blogs/2023-04-23-dbt-from-scratch/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-04-23-dbt-from-scratch"])
      });
    }
  